import React from 'react';
import { Box, Container, Typography, Paper, Link, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(10px)',
  borderRadius: '15px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
}));

const Impressum = () => {
  return (
    <Container maxWidth="md">
      <StyledPaper>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Impressum
        </Typography>
        
        <Typography variant="h6" gutterBottom>
          Angaben gemäß § 5 TMG
        </Typography>
        
        <Typography paragraph>
          Hermann Huber<br />
          Jägerstraße 14<br />
          72213 Altensteig<br />
          Deutschland
        </Typography>

        <Typography variant="h6" gutterBottom>
          Kontakt
        </Typography>
        
        <Typography paragraph>
          E-Mail: <Link href="mailto:info@thigal.de" sx={{ color: '#ff8c00' }}>hermann@cyberlagebild.de</Link>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Haftungsausschluss
        </Typography>
        
        <Typography paragraph>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehme ich keine Haftung für die Inhalte externer Links.
          Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Datenschutzerklärung
        </Typography>
        
        <Typography paragraph>
          Eine ausführliche Datenschutzerklärung findest du hier:
          <Link component={RouterLink} to="/privacy" sx={{ color: '#ff8c00' }}>
            Datenschutzerklärung
          </Link>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Urheberrecht
        </Typography>
        
        <Typography paragraph>
          Alle Inhalte dieser Webseite sind urheberrechtlich geschützt.
          Beiträge Dritter sind als solche gekennzeichnet.
        </Typography>
      </StyledPaper>
      <Button
        component={RouterLink}
        to="/"
        startIcon={<ArrowBackIcon />}
        sx={{ mt: 2, color: '#ff8c00' }}
      >
        Zurück zur Startseite
      </Button>
    </Container>
  );
};

export default Impressum; 